<template>
  <div class="area_code" @click.stop>
    <div class="area" @click="show = true">
      <div class="img" :style="{ backgroundPosition: items.position }"></div>
      <div class="area_text">{{ items.code }}</div>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker show-toolbar :confirm-button-text="$t('My.Button.Two')" :default-index="defaultIndex"
        :cancel-button-text="$t('My.Button.One')" :columns="areaData" @cancel="show = false" @confirm="onConfirm">
        <template #option="item">
          <div class="options">
            <div class="img" :style="{ backgroundPosition: item.position }"></div>
            {{ item.title }} {{ item.code }}
          </div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>
<script>
import { USERS_COUNTRY } from "@/api"
import { Toast, Picker, Popup } from "vant";
import { mapGetters } from "vuex";
export default {
  components: {
    [Picker.name]: Picker,
    [Popup.name]: Popup
  },
  props: {
    value: {
      type: Number,
      default: '',
    },
  },
  data() {
    return {
      show: false,
      defaultIndex: 2
    }
  },
  mounted() {
    // this.getCountry();
  },
  computed: {
    ...mapGetters(["areaData"]),
    items() {
      let areas = JSON.parse(JSON.stringify(this.areaData))
      const list = areas.find(item => item.name == this.value);
      const index = areas.findIndex(item => item.name == this.value)
      this.defaultIndex = index;
      if (!this.value) {
        this.$emit('confirm', areas[0] || {});
        return areas[0] || {}
      }
      this.$emit('confirm', list);
      return list || {}
    },
  },
  methods: {
    onConfirm(value) {
      this.$emit('input', value.name);
      this.show = false;
    },
    async getCountry() {
      Toast.loading();
      try {
        const res = await USERS_COUNTRY();
        this.areaData = res.data;
        Toast.clear();
      } catch (error) {
        Toast.clear();
      }
    }
  }
}
</script>
<style lang="less" scoped>
.area {
  display: flex;
  align-items: center;
  padding-left: 10px;

  .img {
    background: url(../assets/new/language.png) no-repeat 0 0;
    -webkit-background-size: 24px 3876px;
    background-size: 24px 3876px;
    width: 24px;
    height: 16px;
    overflow: hidden;
  }

  .area_text {
    margin-left: 5px;
    color: var(--black);
    font-size: 14px;
  }
}

.options {
  display: flex;
  align-items: center;
  gap: 5px;

  .img {
    background: url(../assets/new/language.png) no-repeat 0 0;
    -webkit-background-size: 24px 3876px;
    background-size: 24px 3876px;
    width: 24px;
    height: 16px;
    overflow: hidden;
  }
}
</style>